import {GDPR_ALL_RIGHTS_FLAG, GDPR_FOOTER_LABEL_ALL_RIGHTS, GDPR_FOOTER_LABEL_ERASURE_ONLY, GDPR_PAGE_PATH} from "@/app/constants/gdpr-rights"
import {isFeatureFlagForced} from "@/app/lib/featureFlags"

// Footer entry of the GDPR page: "Supprimer mes données" while only the erasure form is public
export function gdprFooterLink(): {href: string; label: string} {
    return {
        href: GDPR_PAGE_PATH,
        label: isFeatureFlagForced(GDPR_ALL_RIGHTS_FLAG) ? GDPR_FOOTER_LABEL_ALL_RIGHTS : GDPR_FOOTER_LABEL_ERASURE_ONLY,
    }
}
